export default __webpack_public_path__ + "static/media/information--bicycles-crossing--g3.6a7abeba.png";